import * as React from "react";

import 'react-datepicker/dist/react-datepicker.css';
import {observer} from "mobx-react";
import {CSSProperties} from "react";

import ReactDatePicker from "react-datepicker";
import {StoreControl, StoreControlProps, StoreControlState} from "../../base/StoreControl";
import {ReactUtilities} from "../../../utilities/react/ReactUtilities";
import {ValidatorBase} from "../../../utilities/validator/ValidatorBase";
import {PropertyValidator} from "../../../utilities/validator/PropertyValidator";
import {StoreBase} from "../../../utilities/Store/StoreBase";
import moment = require("moment");


@observer
export class RNDatePicker<S extends StoreBase> extends StoreControl<RNDatePickerProps<S>, RNDatePickerState> {
    static defaultProps: Partial<RNDatePickerProps<any>> = {};

    constructor(props: RNDatePickerProps<S>, context?: any) {
        super(props, context);
        this.state={
            ErrorMessage:'',
            IsValid:true
        }
    }

    public render() {
        return (

            <div className={'rncontrol '+(this.state.IsValid?'':'has-errors')} style={this.props.style}>
                <label style={{width: '100%'}}>{this.props.Label}</label>
                <ReactDatePicker className={'rnform-control'} onChange={(e) => {
                    if(e==null)
                        this.SetValue(0);
                    else{

                        let result=moment(e).add(e.utcOffset(), 'm');

                        this.SetValue( result.unix())
                    }

                }} selected={this.GetDateValue()}/>
                {this.GetValidationSection()}
            </div>


        )
    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return this.GetNumericValue()>0},"Required field")
        ];
    }




}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNDatePickerProps<P extends StoreBase> extends StoreControlProps<P>{
    style?:CSSProperties;
    Label:string;

}

interface RNDatePickerState extends StoreControlState{

}

//#endregion "My Region"